// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ACn2","image":"Header_image__mHkH9","name":"Header_name__Is3cs","info":"Header_info__1kWqR","infoRow":"Header_infoRow__3KbIF"};